import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; // Import Link
import {
  StyledHeader,
  StyledNavLink,
  CenterNavLinks,
  RightNavLinks,
  HeaderContainer,
  LogoContainer,
  NavItem,
  DiscoverDropdownContainer,
  DiscoverDropdownContent,
  DropdownLink,
  StyledDiscoverLink,
  DropdownDivider
} from './styled';
import { ChevronDown, ChevronUp } from 'react-feather';
import Logo from '../../assets/images/Sparkle-logo-full.png';
import { ROUTE_PATH } from '../../constants/routePath';
import HamburgerMenu from './HamburgerMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBagShopping } from '@fortawesome/free-solid-svg-icons';

const DropdownMenu = ({ title, items, isActive }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <DiscoverDropdownContainer
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      <StyledDiscoverLink isActive={isActive}>
        {title} <span style={{ marginLeft: '6px' }}>{isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}</span>
      </StyledDiscoverLink>
      {isOpen && (
        <DiscoverDropdownContent>
          {title === "Products" ? (
            // For Products dropdown, add dividers between sections
            <>
              <DropdownLink key="all-products" onClick={items[0].onClick}>
                {items[0].label}
              </DropdownLink>

              <DropdownDivider />

              {/* Special offers through Eco-friendly (items 1-6) */}
              {items.slice(1, 7).map((item, index) => (
                <DropdownLink key={index + 1} onClick={item.onClick}>
                  {item.label}
                </DropdownLink>
              ))}

              <DropdownDivider />

              {/* Clothing categories, accessories, etc (items 7-12) */}
              {items.slice(7).map((item, index) => (
                <DropdownLink key={index + 7} onClick={item.onClick}>
                  {item.label}
                </DropdownLink>
              ))}
            </>
          ) : (
            // For other dropdowns, just show items normally
            items.map((item, index) => (
              <DropdownLink key={index} onClick={item.onClick}>
                {item.label}
              </DropdownLink>
            ))
          )}
        </DiscoverDropdownContent>
      )}
    </DiscoverDropdownContainer>
  );
};

const Header = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSignUp = () => {
    window.location.href = `https://admin.sparkle.store${ROUTE_PATH.REGISTER}`;
  };
  const handleLoginUp = () => {
    // Check if we're on a shop URL
    if (window.location.pathname.includes('/shop')) {
      // Navigate to customer login
      window.location.href = '/customer/login';
    } else {
      // Original behavior for other pages
      window.location.href = `https://admin.sparkle.store${ROUTE_PATH.MYSTORE}`;
    }
  };

  const isActive = (path) => {
    if (path === ROUTE_PATH.HOME) {
      return window.location.pathname === path;
    }
    return window.location.pathname.startsWith(path);
  };

  const isDiscoverActive = () => {
    return ['/creator/link-in-bio-for-instagram', '/creator/link-in-bio-for-tiktok', '/creator/link-in-bio-for-twitter', '/creator/link-in-bio-for-linkedin'].some(path =>
      window.location.pathname.startsWith(path)
    );
  };
  const isCreateActive = () => {
    // Add logic here to determine when Create should be active
    return ['/create/custom-tshirts', '/create/custom-mugs'].some(path =>
      window.location.pathname.startsWith(path)
    );
  };
  const isShopActive = () => {
    return window.location.pathname.startsWith('/shop');
  };

  const isOnShopUrl = () => {
    return window.location.pathname.includes('/shop');
  };

  const isProductsActive = () => {
    return ['/all-products', '/special-offers', '/embroidery-products', '/fast-delivery',
      '/new-products', '/bestsellers', '/eco-friendly', '/mens-clothing', '/womens-clothing',
      '/kids-youth-clothing', '/home-living', '/hats', '/view-all-products'].some(path =>
        window.location.pathname.startsWith(path)
      );
  };

  const discoverItems = [
    { label: 'Sparkle for Instagram', onClick: () => window.location.href = ROUTE_PATH.INSTAGRAM },
    { label: 'Sparkle for TikTok', onClick: () => window.location.href = ROUTE_PATH.TIKTOK },
    { label: 'Sparkle for Twitter', onClick: () => window.location.href = ROUTE_PATH.TWITTER },
  ];
  const createItems = [
    { label: 'Custom Products', onClick: () => window.location.href = ROUTE_PATH.CUSTOMPRODUCTS },
    { label: 'Custom T-Shirts', onClick: () => window.location.href = ROUTE_PATH.TSHIRT },
    { label: 'Design Library', onClick: () => window.location.href = ROUTE_PATH.DESIGNS },
    //{ label: 'Custom Mugs', onClick: () => {/* Add navigation logic */} },
  ];

  const productItems = [
    { label: 'All products', onClick: () => window.location.href = '/custom-products' },
    { label: 'Special offers', onClick: () => window.location.href = '/custom-products' },
    { label: 'Embroidery products', onClick: () => window.location.href = '/custom-products' },
    { label: 'Fast delivery', onClick: () => window.location.href = '/custom-products' },
    { label: 'New products', onClick: () => window.location.href = '/custom-products' },
    { label: 'Bestsellers', onClick: () => window.location.href = '/custom-products' },
    { label: 'Eco-friendly', onClick: () => window.location.href = '/custom-products' },
    { label: 'Men\'s clothing', onClick: () => window.location.href = '/custom-products' },
    { label: 'Women\'s clothing', onClick: () => window.location.href = '/custom-products' },
    { label: 'Kids & youth clothing', onClick: () => window.location.href = '/custom-products' },
    { label: 'Home & living', onClick: () => window.location.href = '/custom-products' },
    { label: 'Hats', onClick: () => window.location.href = '/custom-products' },
    { label: 'View all products', onClick: () => window.location.href = '/custom-products' },
  ];

  return (
    <StyledHeader>
      <HeaderContainer>
        <LogoContainer>
          {/* Wrap the img with Link pointing to the home page */}
          <Link to={ROUTE_PATH.HOME}>
            <img src={Logo} alt="Sparkle Logo" style={{ display: 'block' }} /> {/* Added display: block */}
          </Link>
        </LogoContainer>
        {isMobile ? (
          <div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
            <StyledNavLink
              style={{
                textDecoration: 'underline',
                fontWeight: '500',
              }}
              onClick={handleLoginUp}
              className="login"            >
              Login
            </StyledNavLink>
              {isOnShopUrl() && (
              <StyledNavLink
                onClick={() => {
                  // Dispatch cart toggle event
                  window.dispatchEvent(new CustomEvent('toggleCart'));
                  // Close hamburger menu if open
                  window.dispatchEvent(new CustomEvent('closeHamburgerMenu'));
                }}
                className="cart"
                style={{
                  marginRight: '1rem',
                  display: 'flex',
                  alignItems: 'center',
                  textDecoration: 'none'
                }}
              >
                <FontAwesomeIcon icon={faBagShopping} size="lg" />
              </StyledNavLink>
            )}

            <HamburgerMenu />
          </div>
        ) : (
          <>
            <CenterNavLinks>
              <NavItem>
                <DropdownMenu title="Products" items={productItems} isActive={isProductsActive()} />
              </NavItem>
              <NavItem>
                <StyledNavLink
                  style={{
                    color: isActive(ROUTE_PATH.TOOLS) ? '#ffe955' : 'white',
                    fontSize: '1.2rem',
                    fontWeight: 'normal', // Explicitly setting normal font weight
                  }}
                  to={ROUTE_PATH.TOOLS}
                >
                  Tools
                </StyledNavLink>
              </NavItem>              <NavItem>
                <DropdownMenu title="Discover" items={discoverItems} isActive={isDiscoverActive()} />
              </NavItem>
              <NavItem>
                <StyledNavLink
                  style={{
                    color: isShopActive() ? '#ffe955' : 'white',
                    fontSize: '1.2rem',
                    fontWeight: 'normal',
                  }}
                  onClick={() => window.location.href = '/shop'}
                >
                  Shop
                </StyledNavLink>
              </NavItem>
              <DropdownMenu title="Create" items={createItems} isActive={isCreateActive()} />
            </CenterNavLinks>            <RightNavLinks>
              <StyledNavLink style={{ textDecoration: 'underline', fontWeight: '500' }} onClick={handleLoginUp} className="login">
                Login
              </StyledNavLink>              {isOnShopUrl() ? (
                <StyledNavLink 
                  onClick={() => {
                    // Close hamburger menu if it's open
                    window.dispatchEvent(new CustomEvent('closeHamburgerMenu'));
                    // Trigger cart toggle - this will need to be implemented via global event or context
                    window.dispatchEvent(new CustomEvent('toggleCart'));
                  }}
                  className="cart"
                  style={{ 
                    fontSize: '1.2rem',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                >
                  <FontAwesomeIcon icon={faBagShopping} />
                  Cart
                </StyledNavLink>
              ) : (
                <StyledNavLink onClick={handleSignUp} className="signup">
                  Sign up free
                </StyledNavLink>
              )}
            </RightNavLinks>
          </>
        )}
      </HeaderContainer>
    </StyledHeader>
  );
};

export default Header;